import React from 'react';
import './ReviewFileUpload.styl';
import CoachingReviewGenericDetails from './CoachingReviewGenericDetails';
import CoachingReviewScorecardDetails, {toPercentage} from './CoachingReviewScorecardDetails';
import partitionBy from 'utils/partitionBy';
import meanBy from 'lodash/meanBy';
import LiveCoachingOverallScore from 'components/coaching/LiveCoachingOverallScore';
import average from 'utils/average';
import CallLink from 'components/coaching/CallLink';
import connectToStores from 'alt-utils/lib/connectToStores';
import ScorecardStore from 'stores/ScorecardStore';
import CardReasonStore from 'stores/CardReasonStore';
import {QUESTION_TYPE_TYPE} from 'records/CoachingReviewTypeQuestion';

@connectToStores
export default class SubmittedReviewFileUpload extends React.PureComponent {
  static getStores() {
    return [ScorecardStore, CardReasonStore];
  }

  static getPropsFromStores() {
    const {reasonSchemes} = CardReasonStore.getState();
    const {scorecardQuestions, scorecardsMap} = ScorecardStore.getState();

    return {
      reasonSchemes,
      questionMap: scorecardQuestions,
      scorecardsMap: scorecardsMap,
    };
  }

  render() {
    const {
      reviewFileUpload,
      scorecardId,
      calls,
      users,
      highLevelScores,
      isLivecoachingPlan,
      scorecardResults,
      coachId,
      isRecipient,
      scorecardsMap,
      questionMap,
      reviewId,
    } = this.props;

    const addedBy = reviewFileUpload.addedByUserId.map(u => users.get(u));
    const call = calls.get(reviewFileUpload.fileuploadId);
    const caller = call ? users.get(call.callerId) : null;

    const scorecard = scorecardsMap.get(scorecardId);
    // XXX EV-18877 it seems wrong to apply the planScorecard's scheme to all review scorecards
    const scoringScheme = scorecard?.scoringScheme ?? QUESTION_TYPE_TYPE.ContentDetail;

    const scores = scorecardResults
      .filter(
        c =>
          c.userId === coachId &&
          // Nulls for value from backend imply question was not answered,
          // so don't include in overall score calculation.
          c.value !== null
      )
      .map(a => toPercentage(a.value, scoringScheme));

    // XXX EV-18877 ideally it should receive numbers in percent to avoid doing any fancy math here
    const averageScore = average(scores);
    return (
      <div className="coaching-review-file-upload">
        <div className="call-info">
          <CallLink
            call={call}
            reviewFileUpload={reviewFileUpload}
            reviewId={reviewId}
            className="callee"
          />
          <div className="added-by">
            added by {addedBy && addedBy.map(u => u && u.getFullName()).join(', ')}
          </div>
        </div>
        <Details
          call={call}
          caller={caller}
          reviewFileUpload={reviewFileUpload}
          highLevelScores={highLevelScores}
          isLivecoachingPlan={isLivecoachingPlan}
          averageScore={averageScore}
          questionMap={questionMap}
          scoringScheme={scoringScheme}
          isRecipient={isRecipient}
          reviewId={reviewId}
        />
      </div>
    );
  }
}

/**
 * If this coaching review includes a metadata only call - just display the high level score
 * Note that this is aggregated up to the skill level by the backend, and to the review level below, even though
 * we display it at the call level.
 */
const Details = ({
  call,
  scoringScheme,
  questionMap,
  reviewFileUpload,
  caller,
  highLevelScores,
  isLivecoachingPlan,
  averageScore,
  isRecipient,
  reviewId,
}) => {
  // TODO: highLevelScores probably should exclude null scores from the average calculation
  //  like highLevelScores.toJS().filter(o => o.score != null)
  const reviewAverage = meanBy(highLevelScores.toJS(), s => s.score);

  if (isLivecoachingPlan) {
    return (
      <div className="details">
        <LiveCoachingOverallScore
          reviewAverage={reviewAverage}
          call={call}
          isRecipient={isRecipient}
          reviewId={reviewId}
        />
      </div>
    );
  }

  const [scorecardBased, generic] = partitionBy(
    reviewFileUpload.reviewFeedbackList,
    feedback => feedback.scorecardQuestionId
  );

  return (
    <div className="details">
      {scoringScheme &&
        questionMap &&
        scorecardBased.map(contentDetailScore => (
          <CoachingReviewScorecardDetails
            key={
              reviewFileUpload.id +
              '|' +
              contentDetailScore.scorecardQuestionId +
              '|' +
              contentDetailScore.contentDetailId
            }
            contentDetailScore={contentDetailScore}
            scoringScheme={scoringScheme}
            questionMap={questionMap}
            isLivecoachingReviewFileupload={reviewFileUpload.livecoaching}
          />
        ))}
      {generic.map(contentDetailScore => (
        <CoachingReviewGenericDetails
          key={reviewFileUpload.id + '|' + contentDetailScore.contentDetailId}
          caller={caller}
          contentDetailScore={contentDetailScore}
        />
      ))}
      {reviewFileUpload.livecoaching && (
        <LiveCoachingOverallScore
          reviewAverage={averageScore}
          call={call}
          isRecipient={isRecipient}
          reviewId={reviewId}
        />
      )}
    </div>
  );
};
